

import React from 'react';

const LegalSection: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
    <div className="mb-6">
        <h3 className="text-xl font-semibold text-light-text-primary dark:text-text-primary mb-3">{title}</h3>
        <div className="text-light-text-secondary dark:text-text-secondary space-y-3 prose dark:prose-invert max-w-none prose-p:text-light-text-secondary prose-p:dark:text-text-secondary prose-strong:text-light-text-primary prose-strong:dark:text-text-primary prose-a:text-blue-600 prose-a:dark:text-blue-400 prose-ul:list-disc prose-ul:ml-6">
            {children}
        </div>
    </div>
);

export const LegalNoticeContent: React.FC = () => (
    <>
        <p className="text-sm text-gray-400 dark:text-gray-500 mb-6">Última actualización: 24 de Julio de 2024</p>
        <LegalSection title="1. Datos del Titular">
            <p>
                <b>Nombre del Titular:</b> Pedro N.S. de Petxus & Taldea<br />
                <b>Correo electrónico:</b> <a href="mailto:info@miscuentas360.com">info@miscuentas360.com</a><br />
                <b>Sitio web:</b> miscuentas360.com<br />
                <b>NIF/CIF:</b> 30605140Y<br />
                <b>Domicilio Fiscal:</b> Urb El Mirabal. Boadilla del Monte. 28660
            </p>
        </LegalSection>
        <LegalSection title="2. Objeto">
            <p>El presente Aviso Legal regula el acceso y uso de la aplicación web "Mis Cuentas 360" (en adelante, la "Aplicación"), que tiene por objeto ofrecer una herramienta para la consolidación de datos financieros, gestión de proyectos y seguimiento de indicadores clave de rendimiento.</p>
        </LegalSection>
        <LegalSection title="3. Propiedad Intelectual e Industrial">
            <p>Todos los derechos de propiedad intelectual e industrial de la Aplicación y de sus contenidos (textos, imágenes, diseño, software, etc.) son titularidad de Petxus & Taldea. Queda prohibida su reproducción, distribución o transformación, total o parcial, sin autorización expresa.</p>
        </LegalSection>
    </>
);

export const PrivacyPolicyContent: React.FC = () => (
     <>
        <p className="text-sm text-gray-400 dark:text-gray-500 mb-6">Última actualización: 24 de Julio de 2024</p>
        <LegalSection title="1. Responsable del Tratamiento">
            <p>
                Pedro NS responsable de Petxus & Taldea Mis Cuentas 360, con correo electrónico <a href="mailto:info@miscuentas360.com">info@miscuentas360.com</a>, es el responsable del tratamiento de los datos personales del usuario.
            </p>
        </LegalSection>
        <LegalSection title="2. Datos que Recopilamos">
            <p>Recopilamos los siguientes datos:</p>
             <p>
                <b>- Datos de registro:</b> Dirección de correo electrónico y contraseña (cifrada).
                <br />
                <b>- Datos financieros y de gestión:</b> Transacciones, categorías, registros de tiempo y reglas que el usuario introduce o importa en la Aplicación. Estos datos se asocian a un identificador de usuario anónimo y no están directamente vinculados a su identidad real fuera de la Aplicación.
                <br />
                <b>- Datos de pago:</b> Al suscribirte, tus datos de pago son gestionados directamente por nuestro proveedor de servicios de pago, Stripe, y no los almacenamos en nuestros servidores.
                <br />
                <b>- Datos de uso:</b> Información anónima sobre cómo interactúas con la Aplicación para mejorar el servicio.
            </p>
        </LegalSection>
        <LegalSection title="3. Finalidad del Tratamiento">
             <p>
                Tus datos se utilizan para:
                <br />- Prestar, mantener y mejorar el servicio de la Aplicación.
                <br />- Gestionar tu suscripción y procesar los pagos a través de Stripe.
                <br />- Sincronizar tus datos entre tus dispositivos.
                <br />- Ofrecer funcionalidades de inteligencia artificial como la categorización automática.
                <br />- Comunicarnos contigo para asuntos relacionados con el servicio.
            </p>
        </LegalSection>
        <LegalSection title="4. Base Legal">
            <p>La base legal para el tratamiento de tus datos es la ejecución del contrato de servicio que aceptas al registrarte y utilizar la Aplicación.</p>
        </LegalSection>
        <LegalSection title="5. Derechos del Usuario">
            <p>
                Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición y portabilidad de tus datos enviando un correo a <a href="mailto:info@miscuentas360.com">info@miscuentas360.com</a>.
            </p>
        </LegalSection>
         <LegalSection title="6. Seguridad">
            <p>
                Implementamos medidas de seguridad técnicas y organizativas para proteger tus datos. Utilizamos Firebase de Google para el almacenamiento y la autenticación, lo que garantiza altos estándares de seguridad.
            </p>
        </LegalSection>
         <LegalSection title="7. Proveedores de Servicios">
            <p>Utilizamos los siguientes proveedores de servicios que pueden tratar tus datos:</p>
            <ul>
                <li><b>Google Firebase:</b> Para la autenticación y base de datos (EE.UU., adherido a marcos de privacidad).</li>
                <li><b>Stripe, Inc.:</b> Para el procesamiento de pagos (EE.UU., adherido a marcos de privacidad).</li>
            </ul>
        </LegalSection>
    </>
);

export const TermsContent: React.FC = () => (
     <>
        <p className="text-sm text-gray-400 dark:text-gray-500 mb-6">Última actualización: 24 de Julio de 2024</p>
        <LegalSection title="1. Aceptación de los Términos">
            <p>Al registrarte y utilizar "Mis Cuentas 360", aceptas estos Términos de Uso y nuestra Política de Privacidad. Si no estás de acuerdo, no debes utilizar la Aplicación.</p>
        </LegalSection>
        <LegalSection title="2. Descripción del Servicio">
            <p>"Mis Cuentas 360" es una herramienta de software como servicio (SaaS) diseñada para la gestión financiera personal y de pequeños proyectos. La Aplicación se proporciona "tal cual" y no garantizamos que se ajuste a tus necesidades específicas.</p>
        </LegalSection>
        <LegalSection title="3. Prueba Gratuita, Suscripciones y Pagos">
            <p>Ofrecemos un período de prueba gratuita de 30 días. Una vez finalizado, necesitarás una suscripción activa (Pago Mensual, Pago Anual o Pago Bianual) para continuar usando el servicio. Los pagos se procesan a través de nuestro proveedor externo, Stripe. Las suscripciones se renuevan automáticamente al final de cada ciclo de facturación. Eres responsable de gestionar tu método de pago a través de Stripe.</p>
        </LegalSection>
        <LegalSection title="4. Política de Cancelación">
            <p>Puedes cancelar tu suscripción en cualquier momento desde tu panel de usuario o contactando con soporte. La cancelación detendrá la renovación automática al final de tu ciclo de facturación actual (mes, año o bienio). Seguirás teniendo acceso al servicio hasta que termine el período que ya has pagado. No se realizarán reembolsos por los períodos ya pagados.</p>
        </LegalSection>
        <LegalSection title="5. Responsabilidades del Usuario">
            <p>Eres responsable de la veracidad de los datos que introduces en la Aplicación y de mantener la confidencialidad de tu contraseña. Eres el único responsable de las decisiones financieras que tomes basándote en la información mostrada.</p>
        </LegalSection>
        <LegalSection title="6. Uso de la Inteligencia Artificial">
             <p>La Aplicación utiliza modelos de IA (Google Gemini) para sugerir categorías y crear reglas. Estas sugerencias son automáticas y pueden contener errores. Es tu responsabilidad revisarlas y confirmarlas.</p>
        </LegalSection>
        <LegalSection title="7. Limitación de Responsabilidad">
            <p>Petxus & Taldea no será responsable de ninguna pérdida de datos, pérdida de beneficios o cualquier otro daño directo o indirecto derivado del uso o la incapacidad de uso de la Aplicación.</p>
        </LegalSection>
         <LegalSection title="8. Modificaciones y Terminación">
             <p>Nos reservamos el derecho de modificar estos términos o de suspender el servicio en cualquier momento. Te notificaremos de los cambios significativos. Puedes dejar de usar el servicio y eliminar tu cuenta en cualquier momento.</p>
        </LegalSection>
    </>
);

export const CookiesPolicyContent: React.FC = () => (
     <>
        <p className="text-sm text-gray-400 dark:text-gray-500 mb-6">Última actualización: 24 de Julio de 2024</p>
        <LegalSection title="1. ¿Qué son las cookies?">
            <p>Una cookie es un pequeño fichero de texto que un sitio web almacena en el navegador del usuario. Las cookies facilitan el uso y la navegación por una página web y son esenciales para el funcionamiento de internet.</p>
        </LegalSection>
        <LegalSection title="2. Cookies que Utilizamos">
            <p>"Mis Cuentas 360" utiliza las siguientes cookies:</p>
            <p><strong>Cookies Técnicas (Estrictamente Necesarias):</strong></p>
             <ul className="list-disc pl-5">
                <li><b>Cookies de Autenticación (Firebase Auth):</b> Esenciales para identificar y mantener tu sesión de usuario. Sin ellas, no podrías acceder a tu cuenta.</li>
                <li><b>Cookie de Consentimiento:</b> Para recordar tu elección (aceptar o rechazar) sobre el uso de cookies en nuestro sitio.</li>
             </ul>
             <p className="mt-4"><strong>Cookies de Terceros (Analíticas y Marketing):</strong></p>
             <ul className="list-disc pl-5">
                <li><b>Google/YouTube:</b> Al mostrar vídeos de YouTube en nuestra página (como los tutoriales), Google puede instalar cookies para analizar el tráfico y mostrar publicidad relevante. Rechazar estas cookies puede impedir la visualización de los vídeos incrustados.</li>
             </ul>
        </LegalSection>
        <LegalSection title="3. Gestión de Cookies">
            <p>Puedes aceptar o rechazar el uso de cookies de terceros a través del banner de cookies. Las cookies técnicas esenciales no se pueden desactivar, ya que son necesarias para el funcionamiento de la Aplicación (por ejemplo, para iniciar sesión).</p>
        </LegalSection>
    </>
);
